import script from "./Destacadas.vue?vue&type=script&setup=true&lang=js"
export * from "./Destacadas.vue?vue&type=script&setup=true&lang=js"

import "./Destacadas.vue?vue&type=style&index=0&id=1eced508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eced508"]])

export default __exports__